import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { NoArvoreResponse } from '@interfaces/corporate-registry/responses/rede-societaria.response';
import { VaultMaskCnpjPipe } from '@shared/pipes/vault-mask-cnpj.pipe';

/**
 * Um nível da árvore societária, como a visão "Árvore" do Dossiê: a empresa e os sócios dela;
 * cada sócio abre as empresas em que também é sócio. Recursivo.
 *
 * Empresa que já apareceu em outro ramo volta do backend como "stub" (`socios: []` com
 * `n_socios > 0`) — mostrar "já exibida acima" evita a pessoa achar que ela não tem sócios.
 */
@Component({
  selector: 'app-registry-tree-node',
  standalone: true,
  imports: [CommonModule, VaultMaskCnpjPipe, RegistryTreeNodeComponent],
  templateUrl: './registry-tree-node.component.html',
  styleUrl: './registry-tree-node.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistryTreeNodeComponent implements OnInit {
  readonly no = input.required<NoArvoreResponse>();
  readonly aberto = input(false);

  protected readonly expandido = signal(false);
  /** Sócios abertos, por índice. */
  protected readonly sociosAbertos = signal<ReadonlySet<number>>(new Set());

  ngOnInit(): void {
    this.expandido.set(this.aberto());
  }

  protected get stub(): boolean {
    return this.no().socios.length === 0 && this.no().n_socios > 0;
  }

  protected alternar(): void {
    this.expandido.update(v => !v);
  }

  protected alternarSocio(i: number): void {
    this.sociosAbertos.update(s => {
      const n = new Set(s);
      if (n.has(i)) {
        n.delete(i);
      } else {
        n.add(i);
      }
      return n;
    });
  }
}
